// extracted by mini-css-extract-plugin
export var footer = "_rr-0";
export var inherit = "_rr-1";
export var input = "_rr-2";
export var modalContent = "_rr-3";
export var quillEditor = "_rr-4";
export var subtitle = "_rr-5";